<template>
  <div id="header">
    <!--h1 id="logo">Yoopies</h1-->
    <div class="container-logo">
      <img src="../assets/images/yoopies.svg" alt="Yoopies" class="logo">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
};
</script>

<style lang="scss" scoped>
#header {
  width: 100%;
  height: 65px;
  margin-left: auto;
  margin-right: auto;
  background-color: #ffffff;
  box-shadow: 0 2px 18px 0 rgba(20, 72, 98, 0.1);
  position: relative;
  z-index: 1;
  min-width: 300px;
  align-items: center;

  @media screen and (min-width: 720px){
    display: flex;
    height: 78px;
  }
}

.container-logo {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  height: 100%;
}

.logo {
  height: 55px;
  margin-left: auto;
  margin-right: auto;

  @media screen and (min-width: 720px){
    margin-left: 50px;
    height: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue